module.exports = __webpack_public_path__ + "img/9788949170602.4f6c1b2e.jpg";